import { render, staticRenderFns } from "./popup.vue?vue&type=template&id=1155b6ba&"
import script from "./popup.vue?vue&type=script&lang=js&"
export * from "./popup.vue?vue&type=script&lang=js&"
import style0 from "./popup.vue?vue&type=style&index=0&id=1155b6ba&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1155b6ba')) {
      api.createRecord('1155b6ba', component.options)
    } else {
      api.reload('1155b6ba', component.options)
    }
    module.hot.accept("./popup.vue?vue&type=template&id=1155b6ba&", function () {
      api.rerender('1155b6ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/banner/popup.vue"
export default component.exports